import React from 'react'
import PropTypes from 'prop-types'

const OrganizationLookupButton = ({ country, style = {} }) => {
	if (!country) return null

	const organizationUrls = {
		'DK': 'https://virk.dk/',
		'NL': 'https://www.kvk.nl/zoeken/',
		'BE': 'https://kbopub.economie.fgov.be/kbopub/zoeknummerform.html',
		'AU': 'https://abr.business.gov.au/',
		'SE': 'https://www.allabolag.se/',
		'DE': 'https://www.unternehmensregister.de/ureg/?submitaction=language&language=en',
		'UK': 'https://find-and-update.company-information.service.gov.uk/',
		'NO': 'https://virksomhet.brreg.no/nb/oppslag/enheter'
	}

	const url = organizationUrls[country]
	if (!url) return null

	const defaultStyle = {
		color: '#3b82f6',
		textDecoration: 'underline',
		cursor: 'pointer',
		...style
	}

	return (
		<a
			href={url}
			target='_blank'
			rel='noopener noreferrer'
			style={defaultStyle}
		>
			Organization Lookup
		</a>
	)
}

OrganizationLookupButton.propTypes = {
	country: PropTypes.string,
	style: PropTypes.object
}

export default OrganizationLookupButton
